import type { SanityPageBuilderSection, SanityPageBuilderShopHeroSection } from "@ouster/shared";
import { ShopHeroBlockView } from "~/features/blocks/inventory/shop-hero";
import { SanityRichText } from "~/features/sanity/rich-text";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderShopHeroSection;
  };
};
export function SanityShopHeroSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  return <ShopHeroBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} hasTopDivider={sectionSettings?.hasTopDivider ?? true} mode={sectionSettings?.mode || "light"} theme={sectionSettings?.theme || "white"} headline={sectionContent.headline} text={sectionContent.text?.length ? <SanityRichText value={sectionContent.text} /> : undefined} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} />;
}